import { render, staticRenderFns } from "./VcColumnButtonGroup.vue?vue&type=template&id=32216b38&scoped=true"
import script from "./VcColumnButtonGroup.vue?vue&type=script&lang=js"
export * from "./VcColumnButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./VcColumnButtonGroup.vue?vue&type=style&index=0&id=32216b38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32216b38",
  null
  
)

export default component.exports